import React from 'react';
import { Check, Package, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { packageContent } from '../data/mock';

const PackageContent = () => {
  const handleBuyClick = () => {
    window.open(packageContent.shopLink, '_blank');
  };

  const handleRentClick = () => {
    window.open(packageContent.rentLink, '_blank');
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="package" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            {packageContent.title}
          </h2>
          <p className="text-xl text-slate-600">
            Kompletny zestaw gotowy do użycia - wszystko czego potrzebujesz w jednym pakiecie
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image section */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src={packageContent.image}
                alt="Zestaw Zosia"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              
              {/* Price badge */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-xl">
                <div className="flex items-end justify-between">
                  <div>
                    <div className="text-sm text-slate-600 mb-1">Cena zestawu</div>
                    <div className="text-4xl font-bold text-orange-600">{packageContent.price}</div>
                  </div>
                  <Package className="w-12 h-12 text-orange-500" />
                </div>
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-br from-orange-400 to-amber-400 rounded-full opacity-20 blur-2xl"></div>
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-gradient-to-br from-amber-400 to-yellow-400 rounded-full opacity-20 blur-2xl"></div>
          </div>

          {/* Content section */}
          <div className="space-y-6">
            <div className="bg-white rounded-3xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-slate-900 mb-6 flex items-center">
                <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-amber-500 rounded-xl flex items-center justify-center mr-3">
                  <Package className="w-5 h-5 text-white" />
                </div>
                Zawartość zestawu
              </h3>

              <ul className="space-y-4">
                {packageContent.items.map((item, index) => (
                  <li
                    key={index}
                    className="flex items-start space-x-3 group"
                  >
                    <div className="flex-shrink-0 w-6 h-6 bg-gradient-to-br from-orange-500 to-amber-500 rounded-full flex items-center justify-center mt-0.5 group-hover:scale-110 transition-transform">
                      <Check className="w-4 h-4 text-white" />
                    </div>
                    <span className="text-slate-700 leading-relaxed group-hover:text-slate-900 transition-colors">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="space-y-3">
              <Button
                onClick={handleBuyClick}
                size="lg"
                className="w-full bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white text-lg py-6 rounded-xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
              >
                Zamów w sklepie Eduko
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>

              <Button
                onClick={handleRentClick}
                size="lg"
                variant="outline"
                className="w-full border-2 border-orange-300 text-orange-600 hover:bg-orange-50 text-lg py-6 rounded-xl"
              >
                💡 Wypożycz na 2 tygodnie (40 zł)
              </Button>
            </div>

            {/* Additional info */}
            {packageContent.additionalInfo && (
              <div className="bg-gradient-to-r from-orange-50 to-amber-50 rounded-xl p-4 border border-orange-200">
                <p className="text-sm text-orange-800 font-medium text-center">
                  {packageContent.additionalInfo}
                </p>
              </div>
            )}

            <p className="text-center text-sm text-slate-500">
              🎁 Odroczony termin płatności dla placówek oświatowych
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PackageContent;
